import { AmLogo } from '@approvalmax/ui';
import { FC } from 'react';

import { useContentScreen } from './Content.hooks';
import { messages } from './Content.messages';
import {
    Company,
    DataTable,
    DataTableCell,
    DataTableHeader,
    DataTableHeaderColumn,
    DataTableRow,
    Date,
    Filter,
    Logo,
    Name,
} from './Content.styles';
import { ContentProps } from './Content.types';

export const Content: FC<ContentProps> = (props) => {
    const { company, reportConfig, reportName } = props;

    const { dateTime, rows, columnsDefinition } = useContentScreen(reportConfig, company);

    return (
        <div>
            <div style={Logo}>
                <AmLogo width='100%' height='100%' />
            </div>

            <div style={Name}>{messages.reportNameHeaderText({ reportName })}</div>

            <div style={Company}>{company.displayName}</div>

            <div style={Date}>{dateTime}</div>

            <div style={Filter}>{reportConfig.filterPreviews.join('\n')}</div>

            <table style={DataTable} cellSpacing='0'>
                <thead>
                    <tr style={DataTableHeader}>
                        {columnsDefinition.map((columnsDefinition) => (
                            <td key={columnsDefinition.column.id} style={DataTableHeaderColumn}>
                                {columnsDefinition.column.name}
                            </td>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} style={DataTableRow}>
                            {row.cells.map((value, index) => {
                                const columnDefinition = columnsDefinition[index].columnDefinition;

                                if (value === null || (Array.isArray(value) && value.length === 0)) {
                                    return (
                                        <td style={DataTableCell} key={index}>
                                            &#8211;
                                        </td>
                                    );
                                }

                                const cellValue = Array.isArray(value) ? value : [value];

                                return (
                                    <td style={DataTableCell} key={index}>
                                        {cellValue.map((value, valueIndex) =>
                                            value ? (
                                                <div key={valueIndex}>{columnDefinition.printCell(value)}</div>
                                            ) : null
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

Content.displayName = 'ContentScreen';
